import { CommonModule } from '@angular/common';
import { Component, computed, HostListener } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatSidenavModule } from '@angular/material/sidenav';
import { RouterOutlet } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { UiTool } from 'src/app/classes/shared/ui.tools';
import { SidenavStore } from 'src/app/services/stores/sidenav.store';
import { HeaderComponent } from '../header/header.component';
import { SidenavComponent } from '../sidenav/sidenav.component';

@Component({
  selector: 'app-project-layout',
  imports: [
    RouterOutlet,
    MatSidenavModule,
    MatButtonModule,
    MatIconModule,
    CommonModule,
    SidenavComponent,
    HeaderComponent,
    TranslateModule,
  ],
  templateUrl: './project-layout.component.html',
  styleUrl: './project-layout.component.scss'
})

export class ProjectLayoutComponent {
  // Sidenav state
  sidenavWidth = computed(() => (this.SidenavStore.sidenavOpen ? '240px' : '64px'));
  isLandscape: boolean = false;

  constructor(
    public serviceTools: UiTool,
    public SidenavStore: SidenavStore
  ) { }

  @HostListener('window:aspect-change', ['$event']) onWindowAspectChange(event: CustomEvent) {
    let { isLandscape } = event.detail;
    this.isLandscape = isLandscape;
  }


  toggleSidenav() {
    this.SidenavStore.toggleSidenav();
  }

}
